import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MASCOT } from '../assets/whyChooseUsImages';

// Reusable mascot that links to the client & team portal chooser.
// variant="hero"  -> large inline image (used in page hero areas)
// variant="float" -> fixed floating button shown on every public page
export const PortalMascot = ({ variant = 'hero' }) => {
  const location = useLocation();

  if (variant === 'float') {
    // Hide on portal chooser, auth, logged-in dashboard, and focused funnel routes to avoid clutter.
    const hidden = /^\/(portal|customer|employee|admin|aqh-mgmt-7816|estimates|invoices?|pay|approve|track)(\/|$)/.test(location.pathname)
      || ['/estimate', '/seasonal-flyer', '/analytics'].includes(location.pathname);
    if (hidden) return null;
    return (
      <Link
        to="/portal"
        aria-label="Open client & team portal"
        data-testid="portal-mascot-float"
        className="hidden md:flex fixed left-4 bottom-24 z-40 group flex-col items-center"
      >
        <span className="mb-1 px-2 py-0.5 rounded-full bg-brand-blue text-white text-[10px] font-semibold shadow opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Portal Login
        </span>
        <img
          src={MASCOT}
          alt="A Quality Handyman mascot — portal login"
          className="w-20 h-20 sm:w-24 sm:h-24 object-contain drop-shadow-xl group-hover:scale-110 transition-transform"
        />
      </Link>
    );
  }

  return (
    <Link
      to="/portal"
      aria-label="Open client & team portal"
      data-testid="portal-mascot-hero"
      className="group flex flex-col items-center text-center"
    >
      <div className="relative">
        <div className="absolute -inset-6 bg-gradient-to-r from-brand-blue to-brand-teal rounded-full opacity-20 blur-2xl" />
        <img
          src={MASCOT}
          alt="A Quality Handyman mascot — click to open the portal"
          className="relative w-56 h-56 sm:w-72 sm:h-72 object-contain drop-shadow-2xl group-hover:scale-105 transition-transform"
        />
      </div>
      <span className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-blue text-white text-sm font-semibold shadow-lg group-hover:bg-brand-teal transition-colors">
        Client &amp; Team Portal Login
      </span>
    </Link>
  );
};

export default PortalMascot;
